import { styled } from 'styled-components';

export const Blockquote = styled.blockquote`
    font-size: ${({ theme }) => theme.typography.body1.fontSize};
    border-left: 2px solid ${({ theme }) => theme.palette.primary.main};
    padding: ${({ theme }) => theme.spacing(2)}px
        ${({ theme }) => theme.spacing(4)};
    margin: 0;
`;
